/** Small badges shared by the session list, detail and activity feed. */
import type { SessionSource, SessionStatus } from '@luminis/protocol';
import type { SessionEventKind } from '../lib/types';
import {
  SESSION_EVENT_KIND_LABELS,
  SESSION_EVENT_KIND_TONES,
  SESSION_SOURCE_LABELS,
  SESSION_SOURCE_TONES,
  SESSION_STATUS_LABELS,
  SESSION_STATUS_TONES,
} from '../lib/sessions';

export function SourceBadge({ source }: { source: SessionSource }) {
  return (
    <span
      className={`rounded-md px-1.5 py-0.5 text-[10px] ${SESSION_SOURCE_TONES[source]}`}
      title={`会话来源：${SESSION_SOURCE_LABELS[source]}`}
    >
      {SESSION_SOURCE_LABELS[source]}
    </span>
  );
}

export function StatusBadge({ status }: { status: SessionStatus }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] ${SESSION_STATUS_TONES[status]}`}
    >
      {status === 'active' ? (
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
      ) : null}
      {SESSION_STATUS_LABELS[status]}
    </span>
  );
}

export function EventKindBadge({ kind }: { kind: SessionEventKind }) {
  return (
    <span className={`rounded border px-1.5 py-0.5 text-[9px] ${SESSION_EVENT_KIND_TONES[kind]}`}>
      {SESSION_EVENT_KIND_LABELS[kind]}
    </span>
  );
}
